import ReceivingScreen from './index';
import CreateScreen from './create';
import DetailScreen from './detail';
import UpdateScreen from './update';

const routes = [
  {
    path: '/receiving/receive',
    component: ReceivingScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.receiving',
    params: {},
  },
  {
    path: '/receiving/receive/create',
    component: CreateScreen,
    action: ['manage'],
    service: 'nvo.wms.receiving',
  },
  {
    path: '/receiving/receive/:id',
    component: DetailScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.receiving',
  },
  {
    path: '/receiving/receive/:id/update',
    component: UpdateScreen,
    action: ['manage'],
    service: 'nvo.wms.receiving',
  },
];

export default routes;
